import React from 'react'
import { t } from 'ttag'
import Pane from 'components/common/Pane'
import Illustration from 'components/common/Illustration'

const Preferences = () => {
  return (
    <Pane title={[t`Preferences`]}>
      <Illustration
        style={{
          maxHeight: '500px',
          width: '100%',
          height: 'auto',
        }}
        alt=""
        name="dashboard"
      />
      <h2>{t`This is how it works`}</h2>
      <p>
        Dolor pariatur debitis recusandae cum excepturi sunt adipisci! Iusto
        rerum blanditiis nemo vitae ex rem culpa! Incidunt consequatur quasi
        voluptatem nisi delectus. Consequuntur iusto molestiae hic minus
        aliquid. Aliquam voluptatem.
      </p>
      <p>
        Dolor ex culpa quas non tenetur. Earum eos dicta nobis unde modi. Modi
        officiis quisquam quae suscipit aut. Nam modi molestias maxime
        voluptatibus deleniti? Distinctio iure ullam vel at cumque.
      </p>
    </Pane>
  )
}

export default Preferences
